import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

import general from '@/store/modules/general'

//funciones auxiliares
import { util } from '@/util.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    G: general,
  },
  state: {
    // store componentes reutilizables
    token: 'esEO_token',

    auth: {
      logueado: false,
      error: '',
      user: {},
      token: '',
      //token: localStorage.getItem(this.token) || "",
    },
    ////////////////////// datos para
    hoteles: {
      destinos: {},
      salidas: {},
      hoteles: {},
      hotel: {},
      turno: {},
      turnos: {
        items: {},
        fields: [
            {key:'sal',label:'Transporte'},
            {key:'fhe',label:'Entrada'},
            {key:'fhs',label:'Salida'},
            {key:'noc',label:'Noches'},
            {key:'pre',label:'Precio'},
            //{key:'lib',label:'*Libres'},
            {key:'action', label:''}
        ],
      },
    },
    rutas: {
      rutas: {},
      ruta: {},
      turno: {},
      turnos: {
        items: {},
        fields: [
            // {key:'sal',label:'Transporte'},
            {key:'fhe',label:'Entrada'},
            {key:'fhs',label:'Salida'},
            {key:'dias',label:'Dias'},
            {key:'pre',label:'Precio'},
            {key:'action', label:''}
        ],
      }
    },
    reserva: {
      id: 0, tpp:'',
    },
    ////////////////////// errores preconfig
    errores: {
      user:   'Usuario No existe',
      passwd: 'Password incorrecto',
      sesion_caducada: 'La sesion iniciada ha caducado, deberá acceder de nuevo.',

      email:  'Email No Correcto',

    },

    ////////////////////// componentes
    modalVisible: false,
    modalComponent: null,

    comps: {

    }

  },
  getters: {
    authToken: state => state.auth.token,

    hotel_imagen: state => (hot) => {
      let url=state.G.url_img + '?w=123|vc_agencias|hoteles_img|' + hot;
      //console.log('hotel_imagen',url);
      return url;
    },

  },
  mutations: {
    //funciones comunes
    loading(state,ok=true,txt='') {
      state.comps.loading.show(ok,txt);
    },
    //alerta
    alerta(state,o=false,t=null) {
      if (!o) {
        o={mensaje:'Mensaje ...',btn:['ok']}
      }
      state.comps.alerta.open(o,t);
    },

    // de momento la buena
    // ventana modal (aceptar) en app
    modal(state,{tit,msg,time}) {
      console.log('modal',tit,msg,time);
      state.comps.modal.show(tit,msg,time);
    },

    /////////////// modal
    showModal(state, componentName) {
      state.modalComponent = componentName;
      state.modalVisible = true;
    },
    hideModal(state) {
      state.modalVisible = false;
    },

    ////////////////////////// login desde actions
    login_back(state,r) {
      //guardamos datos
      if (r.error) {
        this.commit('login_off',r.datos);
      } else {
        state.auth.logueado=true;
        //state.auth.token=r.datos.token;
        state.auth.user=r.datos.user;
        state.auth.error='';
      }
      state.auth.token=r.datos.token;
      sessionStorage.setItem(state.token,r.datos.token);

      console.log('** STORE.LOGIN_BACK',r,state.auth);
    },

    login_off(state,err='') {
      state.auth.token='';
      state.auth.logueado=false;
      state.auth.error=err;
      state.auth.user={};
      //llamar para quitar sesion ??????
      //sessionStorage.clear;
      sessionStorage.removeItem(state.token);
      console.log("* store.login_off",state.auth.token,sessionStorage);
    },

    ///////////////////////////////////////////////////////////
    hoteles_back(state,r) {
      state.hoteles.hoteles=r;
      state.hoteles.hotel={};
      state.hoteles.turno={};
      state.hoteles.turnos.items={};
    },
    rutas_back(state,r) {
      state.rutas.rutas=r;
      state.rutas.ruta={};
      state.rutas.turno={};
      state.rutas.turnos.items={};
    },

  },
  actions: {

    async isLogin(context) {
      context.state.auth.token=sessionStorage.getItem(context.state.token) || "";
      let token = context.getters["authToken"];

      console.log("* store.isLogin",token);

      if (!token) {
        context.commit('login_off');
        return;
      }

      let arg={ token: context.state.auth.token };
      await context.dispatch('login',arg);
    },

    async login(context,args) {
      context.commit('loading');
      //let args={ atoken: context.state.auth.token };
      let r=await context.dispatch('exec',{api:'login', arg:args});
      context.commit('login_back',r);
      context.commit('loading',false);
    },

    async datos_iniciales(context) {
      console.log("* store.datos_iniciales -- sin datos", context.state.auth.user);

    },

    // hoteles - hoteles_precios
    async hoteles(context) {

      //let args={ sid: context.state.auth.user.sid };
      var args={ sid: context.getters["authToken"] };
      let r=await context.dispatch('exec',{api:'hoteles', arg:args});
      console.log('** store.hoteles', r.datos, context.getters["authToken"]);

      context.commit('hoteles_back', r.datos);
    },

    async hotel_precios(context,item=null) {
        console.log("store.hotel_precios",item, context.getters["authToken"]);

        //if (item!=null) context.state.hoteles.hotel=item;

        let args={ hot: item.hot, sid: context.getters["authToken"] };
        let r=await context.dispatch('exec',{api:'hoteles_turnos', arg:args});

        let res=await context.dispatch('error',{r});
        if (res) r.datos=[];

        context.state.hoteles.turnos.items = util.object_array(r.datos);
        return !res;
    },

    // rutas
    async rutas(context) {

      let args={ sid: context.state.auth.user.sid };
      let r=await context.dispatch('exec',{api:'rutas', arg:args});

      context.commit('rutas_back', r.datos);
    },
    async rutas_precios(context,item) {
      context.state.rutas.ruta=item;

      let args={ hot: item.hot, sid: context.state.auth.user.sid };
      let r=await context.dispatch('exec',{api:'hoteles_turnos', arg:args});

      if (r.error) {
          context.commit('modal',{tit:"Hoteles", msg: r.datos});
      }
      context.state.turnos.items = util.object_array(r.datos);
    },

    ///////////////////////////////////////////////////////////////
    //exec
    async exec(context, {api, arg}) {
      let A=context.state.G.abk_url;
      A.fnt=api;
      A.args=arg;
      let r = await context.dispatch("ajaxRequest", A);
      return r;
    },

    //ajax
    async ajaxRequest(context,args) {
      console.log("------------AJAXREQUEST ", args);
      try {
        return Axios.post(context.state.G.url, args, {
          headers: {
              "Content-Type": "application/json"
          }
        }).then(result => {
          console.log("------------AJAXREQUEST RECIBIDO: ", result.data);
          if (!result.data.error==='undefined') {
            alert(result.data);
            return false;
          }
          return result.data;
        })
      } catch (error) {
        // error en la recuperación de datos
        console.log("------------AJAXREQUEST ERROR !!!!!!", error);
        return false;
      }
    },

    // errores
    async error(context, {r}) {
      let OK,KO=false;

      if (r.error) {
        let m=r.datos;
        //let e=false;
        if (m=='error:200') { m='Se ha producido un Error.<br>La sesion iniciada se cerrará.<br>Debe acceder de nuevo.'; KO=true; }
        if (m=='error:201') { m='La sesion iniciada se cerrará.<br>Ha superado el tiempo de Inactividad de su sesión.<br>Debe acceder de nuevo.'; KO=true; }

        context.commit('modal',{tit:"Hoteles", msg: m});
        //this.modal({tit: this.modulo, msg: m});

        if (KO) {
          context.commit('login_off');
          this.$router.push('/');
        }

        OK=true;
      }
      console.log('**store.error',r,OK,KO);

      return OK;
    },
  }
})
